/* eslint-disable */
import { useEffect } from 'react';
import './App.css';
import { useDispatch } from "react-redux";
import { loginSuccess } from './Redux/auth/action';
import Routes from './Routes/Routes';
import { FooterContainer } from './Components/FooterContainer';

function App() {
const dispatch = useDispatch();

  useEffect(() => {
      const IsAuthenticated = async () => {
     const authToken = localStorage.getItem('authToken');
     const user = JSON.parse(localStorage.getItem('user'));
     
     if (authToken){
      dispatch(loginSuccess(user));
      if (!user.is_admin) {    
        return
      }
     }  
  };
  IsAuthenticated()
}, []);


  return (
    < div className = "App">
      <Routes/>
      <FooterContainer />
 
    </div>

  );
}
export default App;
